/** End/tear-down applies once the run is past participant setup, not while still configuring. */
export function canEndExerciseRun(status: string | undefined): boolean {
  const s = (status ?? '').toLowerCase();
  if (!s) return false;
  const preStart = new Set([
    'participants_pending',
    'participants_added',
    'launching',
    'launched',
  ]);
  const terminal = new Set(['completed', 'cancelled', 'failed']);
  if (preStart.has(s) || terminal.has(s)) return false;
  return true;
}

/** Exercise play is live (green “Active” indicator). */
export function isRunStatusStarted(status: string | undefined): boolean {
  return (status ?? '').toLowerCase() === 'started';
}
